import { OrganizationKeyName } from "../../../model/Organization";
import { ShopListItem } from "../model/ShopListSuccessResponse";

export const GET_SHOP_LIST_SUCCESS = "SHOP:GET_SHOP_LIST_SUCCESS";

export const getShopListSuccessAction = (
  organization: OrganizationKeyName,
  data: ShopListItem[]
) => ({
  type: GET_SHOP_LIST_SUCCESS as typeof GET_SHOP_LIST_SUCCESS,
  organization,
  data,
});

export type GetShopListSuccessAction = ReturnType<
  typeof getShopListSuccessAction
>;
